<section class="simulation grid-container login-page" id="otpConnexionPage" data-overload-controller="LoginPegaseCtrl">
    <div>
        <div class="page-header">
            <p class="simulation__panelTitle page-title">
                {{ 'accountactivation.title' | i18n }}
            </p>
        </div>
        <div class="login-page__content otp-connexion">
            <form [formGroup]="otpForm" (ngSubmit)="validateOtp()" class="">
                <div class="login-page__block">
                    <div class="sms-sended">
                        {{ 'otp.connexion.sms.sended' | i18n }}<br />
                        {{ 'otp.connexion.sms.sended.phone' | i18n }}&nbsp;{{ phone }}<br /><br />
                    </div>
                    <div class="enter-code">
                        {{ 'otp.connexion.enter.code' | i18n }}<br />
                        <input class="textfield" id="otp" formControlName="otp" name="otp" pattern="[0-9]{6}" maxlength="6" type="text" required="" [ngClass]="{ 'ng-invalid': isError }" [readOnly]="!isOtpCalculate" />
                    </div>
                    <div *ngIf="isError">
                        <div class="enter-code-error" [innerHTML]="keyMsgError | i18n"></div>
                    </div>
                    <div class="sms-sended">
                        <br />{{ 'otp.connexion.sms.none' | i18n }}
                        <span id="resend_sms" (click)="calculateOtp()" data-tag-commander="" [appTagCommander]="'tagCo.sms.resend.button'" class="login-box__link" [ngClass]="{ 'span--disabled': isLoading }">
                            {{ 'otp.connexion.sms.resend' | i18n }}
                        </span>
                    </div>
                </div>
                <div class="grid-12 login-page__input simulation__group login-page__block login-page__button validate-otp-btn">
                    <button id="otp_connexion_btn" type="submit" [ngClass]="{ 'icon--loading': isLoading }" class="grid-6 push-3 grid-mobile-4 push-mobile-0 button button--primary" data-api-call-button="" [disabled]="!otpForm.valid">
                        {{ 'otp.connexion.validate' | i18n }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</section>
